// src/pages/ModuleList.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";

// Course Modules Data
const modulesData = {
  "cyber-security": [
    { id: "1", title: "Introduction & Orientation" },
    { id: "2", title: "Network Security Basics" },
    { id: "3", title: "OWASP Top 10 Overview" },
    { id: "4", title: "Mini Project Setup" },
    { id: "5", title: "Assessment & Feedback" },
  ],
  "python-programming": [
  { "id": "1", "title": "Day 1: Introduction to Python – What is Python, why use it, installing Python, setting up IDE (PyCharm, VSCode, Jupyter Notebook)" },
  { "id": "2", "title": "Day 2: Writing your first Python program – 'Hello World', understanding syntax, comments, and indentation rules" },
  { "id": "3", "title": "Day 3: Variables and Data Types – integers, floats, strings, booleans; type conversion and type checking" },
  { "id": "4", "title": "Day 4: Taking user input, printing output, and string formatting techniques" },
  { "id": "5", "title": "Day 5: Conditional Statements – if, if-else, elif, nested if statements with examples" },
  { "id": "6", "title": "Day 6: Loops – for loop, while loop, nested loops, and the range() function" },
  { "id": "7", "title": "Day 7: Loop control statements – break, continue, pass, and simple exercises" },
  { "id": "8", "title": "Day 8: Lists – creating, indexing, slicing, adding, removing, updating elements" },
  { "id": "9", "title": "Day 9: Tuples – creating, accessing elements, immutability, tuple methods" },
  { "id": "10", "title": "Day 10: Dictionaries – key-value pairs, adding, updating, deleting, dictionary methods" },
  { "id": "11", "title": "Day 11: Sets – creating, adding/removing elements, set operations (union, intersection)" },
  { "id": "12", "title": "Day 12: Functions – defining, calling, parameters, return values, default arguments" },
  { "id": "13", "title": "Day 13: Lambda functions and map(), filter(), reduce() usage" },
  { "id": "14", "title": "Day 14: Practice session – problems on lists, dictionaries, functions" },
  { "id": "15", "title": "Day 15: File Handling – reading and writing text files, working with CSV files" },
  { "id": "16", "title": "Day 16: Error Handling – try-except, finally, raising exceptions, custom exceptions" },
  { "id": "17", "title": "Day 17: Introduction to Object-Oriented Programming (OOP) – classes and objects" },
  { "id": "18", "title": "Day 18: Attributes and methods – instance variables, class variables, instance methods" },
  { "id": "19", "title": "Day 19: Constructors (__init__ method) and object lifecycle" },
  { "id": "20", "title": "Day 20: Inheritance – single, multiple, multilevel, method overriding" },
  { "id": "21", "title": "Day 21: Practice session – OOP-based exercises" },
  { "id": "22", "title": "Day 22: Project Introduction – Student Grade Management System requirements and planning" },
  { "id": "23", "title": "Day 23: Implementing student data input and grade calculation logic" },
  { "id": "24", "title": "Day 24: Storing data in a file and retrieving it on program start" },
  { "id": "25", "title": "Day 25: Adding search functionality for student results by roll number" },
  { "id": "26", "title": "Day 26: Testing and debugging the project" },
  { "id": "27", "title": "Day 27: Final project completion and preparing submission files" },
  { "id": "28", "title": "Day 28: Submission review and certificate distribution" }
],
  "ai-ml": [
  { "id": "1", "title": "Python Basics & Syntax" },
  { "id": "2", "title": "NumPy" },
  { "id": "3", "title": "Pandas" },
  { "id": "4", "title": "Matplotlib & Seaborn" },
  { "id": "5", "title": "Exploratory Data Analysis (EDA)" },
  { "id": "6", "title": "Supervised vs Unsupervised Learning" },
  { "id": "7", "title": "Linear Regression" },
  { "id": "8", "title": "Logistic Regression" },
  { "id": "9", "title": "Model Evaluation: Accuracy, Confusion Matrix, Precision, Recall" },
  { "id": "10", "title": "K-Nearest Neighbors (KNN)" },
  { "id": "11", "title": "Decision Trees" },
  { "id": "12", "title": "Random Forest" },
  { "id": "13", "title": "K-Means Clustering" },
  { "id": "14", "title": "Classification & Clustering Mini Projects" },
  { "id": "15", "title": "Handling Missing Values, Scaling, Encoding" },
  { "id": "16", "title": "Feature Selection Techniques" },
  { "id": "17", "title": "Building ML Pipelines" },
  { "id": "18", "title": "Text Preprocessing: Tokenization, Stemming, Stopwords" },
  { "id": "19", "title": "Bag-of-Words & TF-IDF" },
  { "id": "20", "title": "Sentiment Analysis Mini Project" },
  { "id": "21", "title": "Introduction to Neural Networks" },
  { "id": "22", "title": "TensorFlow / Keras Basics" },
  { "id": "23", "title": "Build a Simple ANN Model" },
  { "id": "24", "title": "Convolutional Neural Networks (CNN)" },
  { "id": "25", "title": "Image Classification with MNIST / CIFAR-10" },
  { "id": "26", "title": "Hyperparameter Tuning (GridSearch, RandomSearch)" },
  { "id": "27", "title": "Cross-Validation" },
  { "id": "28", "title": "Overfitting & Underfitting Handling" },
  { "id": "29", "title": "Mini Project: Spam Detection / Fake News / Recommendation System" },
  { "id": "30", "title": "Flask / Streamlit App Development" },
  { "id": "31", "title": "Deploy ML Model to Web" },
  { "id": "32", "title": "UI Integration Basics" },
  { "id": "33", "title": "Mini Project: Face Recognition / Chatbot / Stock Prediction" },
  { "id": "34", "title": "Final Project Demo" },
  { "id": "35", "title": "GitHub Submission & Resume Update" },
  { "id": "36", "title": "Feedback Session & Certificate Distribution" }
],
  "web-dev": [
    { id: "1", title: "HTML/CSS/JS Basics" },
    { id: "2", title: "React + Tailwind Setup" },
    { id: "3", title: "APIs & Routing" },
    { id: "4", title: "Mini Project" },
    { id: "5", title: "Final Review" },
  ],
  "blockchain": [
    { id: "1", title: "What is Blockchain?" },
    { id: "2", title: "Smart Contracts" },
    { id: "3", title: "Metamask & Remix" },
    { id: "4", title: "Mini DApp Build" },
    { id: "5", title: "Wrap-Up & Quiz" },
  ],
};

const ModuleList = () => {
  const { id } = useParams();
  const modules = modulesData[id];

  if (!modules) {
    return (
      <div className="min-h-screen bg-[#0f172a] text-white flex justify-center items-center">
        <h2 className="text-xl font-medium">Modules not found for this course.</h2>
      </div>
    );
  }

  const formattedCourseTitle = id.replace(/-/g, " ").toUpperCase();

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200 text-gray-900 px-4 md:px-6 py-20 max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-indigo-600 mb-10">
        {formattedCourseTitle} - Modules
      </h2>

      <div className="space-y-4">
        {modules.map((mod) => (
          <Link
            to={`/courses/${id}/modules/${mod.id}`}
            key={mod.id}
            className="block bg-gradient-to-r from-indigo-500 to-purple-600 p-5 rounded-xl shadow-lg transform transition duration-300 hover:scale-[1.03] hover:shadow-xl"
            aria-label={`Go to module ${mod.title}`}
          >
            <h3 className="text-lg md:text-xl font-semibold text-white">{mod.title}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ModuleList;
